import(/* webpackMode: "eager" */ "/var/www/stms/FrontEnd/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/stms/FrontEnd/src/app/welcome/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/var/www/stms/FrontEnd/src/components/welcome/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/var/www/stms/FrontEnd/src/components/welcome/header.tsx");
